module.exports = __webpack_public_path__ + "img/road_roller_h.d90fdd36.png";